import _regeneratorRuntime from "D:\\workFile\\qingbeiCode\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CourseSoldOutTip from "@/modules/stu/components/CourseSoldOutTip.vue";
import CoursePeriodsType from "@/modules/stu/components/CoursePeriodsType";
import CourseContentTip from "@/modules/stu/components/CourseContentTip";
export default {
  name: "CoursePeriod",
  components: {
    CourseSoldOutTip: CourseSoldOutTip,
    CoursePeriodsType: CoursePeriodsType,
    CourseContentTip: CourseContentTip
  },
  props: {
    period: {
      type: Object
    },
    course: {
      type: Object
    },
    tryText: {
      type: String,
      default: "试看"
    },
    isVideo: {
      type: Boolean
    },
    onPeriodTap: {
      type: Function
    }
  },
  data: function data() {
    return {
      parent: this.$route.query.parent,
      period_id: this.$route.query.period_id,
      showContentDialog: false,
      chapter_content: "",
      showSoldOut: false
    };
  },
  watch: {
    $route: {
      handler: function handler() {
        this.period_id = this.$route.query.period_id;
      },
      // 深度观察监听
      deep: true
    }
  },
  computed: {
    commonSetting: function commonSetting() {
      return this.$store.state.commonSetting;
    },
    type: function type() {
      return this.period.periods_type;
    },
    // 是否是会员
    isShowVipFree: function isShowVipFree() {
      if (this.$store.state.token && this.course.vipData.is_vip_course == 1) {
        return true;
      }

      return false;
    },
    // video页混合课
    videoMixCoures: function videoMixCoures() {
      if (this.isVideo) {
        return true;
      } else {
        return false;
      }
    }
  },
  created: function created() {
    // this.period.teachers = this.period.teachers.map(i => {
    //   return i.teacher_name;
    // });
    this.period.play_type = this.isLive(this.period.start_op_time, this.period.end_op_time);
  },
  methods: {
    isLive: function isLive(start, end) {
      //  1未开播  2直播中  3直播结束
      if (start == 0) {
        return 1;
      } //未开播


      if (start != 0 && end == '') {
        return 2;
      } //直播中


      if (start != 0 && end != '') {
        return 3;
      } //直播结束

    },
    onPreview: function () {
      var _onPreview = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(file) {
        var data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!this.course.is_buy && !this.isShowVipFree)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", this.$info("请您先报名"));

              case 2:
                if (!(file.file_ext == "mp3" || file.file_ext == "mp4")) {
                  _context.next = 9;
                  break;
                }

                _context.next = 5;
                return this.$http.get("/api/app/user/CourseWare/video/preview", {
                  video_id: file.fid
                });

              case 5:
                data = _context.sent;
                window.open(data[0].url);
                _context.next = 10;
                break;

              case 9:
                // let data = await this.$http.get("/api/app/user/CourseWare/preview", {
                //   fid: file.fid,
                // });
                // window.open(data);
                window.open(file.file_url);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onPreview(_x) {
        return _onPreview.apply(this, arguments);
      }

      return onPreview;
    }(),
    visitFile: function () {
      var _visitFile = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(id, index) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.course.is_buy == 0)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", this.$info("请您先报名"));

              case 2:
                _context2.next = 4;
                return this.$services.CourseService.openPeriodFile(this.period, id, index, this.parent);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function visitFile(_x2, _x3) {
        return _visitFile.apply(this, arguments);
      }

      return visitFile;
    }(),
    targetPeriod: function () {
      var _targetPeriod = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(period, type) {
        var data;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.$services.CourseService.checkLiveState(this.type, period)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                if (!(this.course.is_buy == 0 && period.is_try_see == 0)) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt("return", this.$info("请您先报名"));

              case 4:
                if (!(this.course.is_buy == 1)) {
                  _context3.next = 9;
                  break;
                }

                _context3.next = 7;
                return this.$services.CourseService.checkLimit(this.course.id);

              case 7:
                if (this.$services.CourseService.checkBuyValid(this.course)) {
                  _context3.next = 9;
                  break;
                }

                return _context3.abrupt("return", this.$info("该课程已过期，无法继续学习"));

              case 9:
                /*
                if (period.bjy_encode_status != 1) {
                  return this.$info("视频转码中，请稍后观看");
                }
                */
                if (this.videoMixCoures && this.type == 5) {
                  this.onPeriodTap();
                }

                if (!(this.type == 7 && this.period.content)) {
                  _context3.next = 14;
                  break;
                }

                this.chapter_content = this.period.content;
                this.showContentDialog = true;
                return _context3.abrupt("return");

              case 14:
                if (!(this.type == 10)) {
                  _context3.next = 22;
                  break;
                }

                _context3.next = 17;
                return this.$services.CourseService.getPeriodContent(period, this.parent);

              case 17:
                data = _context3.sent;
                this.chapter_content = data.course_content;
                this.showContentDialog = true;
                _context3.next = 25;
                break;

              case 22:
                if (!type) {
                  type = 1;
                }

                _context3.next = 25;
                return this.$services.CourseService.watchVideo(period, this.type, this.course.id, type);

              case 25:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function targetPeriod(_x4, _x5) {
        return _targetPeriod.apply(this, arguments);
      }

      return targetPeriod;
    }()
  }
};